<div class="container">
  <div class="row head">
    <div class="col-12 col-sm-8">
      <span class="title"  i18n="parametersusers|@@users">Utilisateurs</span>
    </div>
    <div class="col-12 col-sm-4">
      <span class="adduser">
        <span i18n="parametersusers|@@addUser">
        Ajouter un utilisateur
        </span>
        <svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink">
          <!-- Generator: Sketch 52.2 (67145) - http://www.bohemiancoding.com/sketch -->
          <title>Shape</title>
          <desc>Created with Sketch.</desc>
          <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="UI-Rapport" transform="translate(-1165.000000, -305.000000)" fill="#0090D3" fill-rule="nonzero">
              <g id="Content" transform="translate(165.000000, 269.000000)">
                <g id="01" transform="translate(14.000000, 24.000000)">
                  <g id="Group-18" transform="translate(784.000000, 9.000000)">
                    <path
                      d="M210,3 C205.6,3 202,6.6 202,11 C202,15.4 205.6,19 210,19 C214.4,19 218,15.4 218,11 C218,6.6 214.4,3 210,3 Z M214,12 L211,12 L211,15 L209,15 L209,12 L206,12 L206,10 L209,10 L209,7 L211,7 L211,10 L214,10 L214,12 Z"
                      id="Shape"></path>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </svg>
      </span>
    </div>
  </div>
  <div class="row">
    <div class="col-12 report-form">
      <div class="table-option-toggle">
        <div class="conatainer">
          <div class="row m-0 center">
            <div class="col-8 col-md-5">
              <span class="column-title" i18n="app-parameters-user|@@option">Utilisateur</span>
            </div>
            <div class="d-none d-md-block col-2">
              <span class="column-title" i18n="app-parameters-user|@@libelle">Type</span>
            </div>
            <div class="col-4 col-md-3">
              <span class="column-title" i18n="app-parameters-user|@@activite">Périmètre</span>
            </div>
            <div class="d-none d-md-block  col-2">
              <span class="column-title" i18n="app-parameters-user|@@actions">Actions</span>
            </div>
          </div>

          <div class="row m-0">
            <div class="col-8 col-md-5 center">
              <span>sofiane.benabdallah@tchek.fr</span>
            </div>
            <div i18n="app-parameters-users|@@admin" class="d-none d-md-block col-2 center">
              Administrateur
            </div>
            <div i18n="app-parameters-users|@@all" class="col-4 col-md-3 center">
              Tous
            </div>
            <div class="d-none d-md-block  col-2 center">
              <svg width="4px" height="16px" viewBox="0 0 4 16" version="1.1" xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink">
                <title>menu-dots</title>
                <desc>Created with Sketch.</desc>
                <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="UI-Rapport" transform="translate(-1231.000000, -191.000000)" fill="#162C4B"
                    fill-rule="nonzero">
                    <g id="Header-Small" transform="translate(165.000000, 153.000000)">
                      <g id="CTA" transform="translate(1050.000000, 23.000000)">
                        <g id="menu-dots"
                          transform="translate(18.000000, 23.000000) rotate(90.000000) translate(-18.000000, -23.000000) translate(10.000000, 21.000000)">
                          <circle id="Oval" cx="8" cy="2" r="2"></circle>
                          <circle id="Oval" cx="2" cy="2" r="2"></circle>
                          <circle id="Oval" cx="14" cy="2" r="2"></circle>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </svg>
            </div>
          </div>

          <div class="row m-0">
            <div class="col-8 col-md-5 center">
              <span>sofiane.benabdallah@tchek.fr</span>
            </div>
            <div i18n="app-parameters-users|@@admin" class="d-none d-md-block col-2 center">
              Administrateur
            </div>
            <div i18n="app-parameters-users|@@All" class="col-4 col-md-3 center">
              Tous
            </div>
            <div class="d-none d-md-block  col-2 center">
              <svg width="4px" height="16px" viewBox="0 0 4 16" version="1.1" xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink">
                <title>menu-dots</title>
                <desc>Created with Sketch.</desc>
                <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="UI-Rapport" transform="translate(-1231.000000, -191.000000)" fill="#162C4B"
                    fill-rule="nonzero">
                    <g id="Header-Small" transform="translate(165.000000, 153.000000)">
                      <g id="CTA" transform="translate(1050.000000, 23.000000)">
                        <g id="menu-dots"
                          transform="translate(18.000000, 23.000000) rotate(90.000000) translate(-18.000000, -23.000000) translate(10.000000, 21.000000)">
                          <circle id="Oval" cx="8" cy="2" r="2"></circle>
                          <circle id="Oval" cx="2" cy="2" r="2"></circle>
                          <circle id="Oval" cx="14" cy="2" r="2"></circle>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </svg>
            </div>
          </div>


          <div class="row m-0">
            <div class="col-8 col-md-5 center">
              <span>sofiane.benabdallah@tchek.fr</span>
            </div>
            <div i18n="app-parameters-users|@@admin" class="d-none d-md-block col-2 center">
              Administrateur
            </div>
            <div i18n="app-parameters-users|@@All" class="col-4 col-md-3 center">
              Tous
            </div>
            <div class="d-none d-md-block  col-2 center">
              <svg width="4px" height="16px" viewBox="0 0 4 16" version="1.1" xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink">
                <title>menu-dots</title>
                <desc>Created with Sketch.</desc>
                <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="UI-Rapport" transform="translate(-1231.000000, -191.000000)" fill="#162C4B"
                    fill-rule="nonzero">
                    <g id="Header-Small" transform="translate(165.000000, 153.000000)">
                      <g id="CTA" transform="translate(1050.000000, 23.000000)">
                        <g id="menu-dots"
                          transform="translate(18.000000, 23.000000) rotate(90.000000) translate(-18.000000, -23.000000) translate(10.000000, 21.000000)">
                          <circle id="Oval" cx="8" cy="2" r="2"></circle>
                          <circle id="Oval" cx="2" cy="2" r="2"></circle>
                          <circle id="Oval" cx="14" cy="2" r="2"></circle>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </svg>
            </div>
          </div>


        </div>
      </div>
    </div>

  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/element/parameters-users/parameters-users.component.html